export default "__VITE_ASSET__BmoY_j0f__"